import { DataExplorerTable } from 'features/data-explorer/types'
import { JobStatusType, ProcessingJob } from 'features/jobs/types'
import JobStatus from './JobStatus'
import NewExport from './NewExport/NewExport'

interface SubscriptionExportDialogContentProps {
  table: DataExplorerTable
  job?: ProcessingJob
  onClose: (jobStatus?: JobStatusType) => void
}

function SubscriptionExportDialogContent({ table, job, onClose }: SubscriptionExportDialogContentProps) {
  return job ? <JobStatus job={job} table={table} onClose={onClose} /> : <NewExport table={table} />
}

export default SubscriptionExportDialogContent
